module.exports = {
    selectLanguage: 'Language:',
    reserve: 'Learn more',
    close: 'Close',
    Title: 'Title*',
    Mr: 'Mr',
    Mrs: 'Mrs',
    Email: 'Email*',
    Firstname: 'First name*',
    Lastname: 'Last name*',
    Message: 'Message',
    Checkbox_waitlist:
        'Yes, I want to join the waitlist. Please send me more information.',
    Checkbox_updates: 'Yes, I want to receive updates.',
    Checkbox_waiting: 'Join the waiting list for Pazola.',
    Form_GDPR:
        'By submitting this form you agree to our <a href="https://www.andermatt-swissalps.ch/en/data-privacy-statement/" target="_blank">privacy policy</a>',
    'Privacy Policy': 'Privacy & cookies',
    privacyLink:
        'https://www.andermatt-swissalps.ch/en/data-privacy-statement/',
    Submit: 'Submit',
    Submiting: 'Submiting',
    'Title is required': 'Title is required',
    'First name must be at least 2 characters':
        'First name must be at least 2 characters',
    'First name is required': 'First name is required',
    'Last name is required': 'Last name is required',
    'Last name must be at least 2 characters':
        'Last name must be at least 2 characters',
    'Invalid email': 'Invalid email',
    'Email is required': 'Email is required',
    'Message is required': 'Message is required',
    'Download Floorplans': 'Download Floorplans',
    'Thank you for getting in touch.':
        'We have received your message and will be in touch with you shortly.',
    'There was an issue submitting the form.':
        'There was an issue submitting the form.',
    CookiesMessage: 'This website uses cookies, which help us to provide our services. By using our services, you consent to the setting of cookies by us.',
    CookiesLink: 'https://www.andermatt-swissalps.ch/en/data-privacy-statement/',
    ACCEPT: 'ACCEPT'
}
